import type { FaireProductEntity } from "../../entity_types/product";

export const p_6322q5wks4: FaireProductEntity = {
  token: "p_6322q5wks4",
  type: "product",
  name: "Houseplant by ripple⁺ Ash & Scent Set",
  brandToken: "b_a9pxh3wj37",
  brandName: "ripple⁺ home",
  imageUrl:
    "https://cdn.faire.com/fastly/9d6923232248b2ef2f0ee120a1e18d7f47178981f1dbf296457e48daa6987707.png",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/5fedc9f9475490c5eb309537c0f89950f7f590dfa6793419b048ceee092db6b9.png",
    "https://cdn.faire.com/fastly/2d98437f1c51f4ba7db4cc1caa07629cb8ec6752052e7d70808dd3086cb40816.png",
    "https://cdn.faire.com/fastly/6a9969d4f3fa6efe277f061546ff5bf602e53d2ff1754bcfaeb233460401c203.png",
    "https://cdn.faire.com/fastly/dcaf29f098297c5637e9d3fa92bd783e7dd5e369a29ee68c2ea6d9c1b954bc92.png",
  ],
  priceDollars: 42.5,
  description:
    "Houseplant by ripple⁺ Ash & Scent Set is a design-led incense experience that combines ritual, fragrance, and form. Curated by Seth Rogen and inspired by the historic fragrance region of Grasse, France, this premium set includes a hand-sculpted marble ashtray that doubles as an incense burner, alongside incense droplets for extended aromatic use.\n\nDesigned as a functional object as much as a fragrance ritual, this set is intended to live permanently in the home — equal parts utility and sculpture.\n\nScent character: Rich, fresh, and smooth\n\n𝗜𝗻𝗰𝗹𝘂𝗱𝗲𝘀:\n• Hand-sculpted marble ashtray / incense burner\n• 64 incense droplets\n\nTotal burn time: 640+ minutes\n\nIdeal for: Incense rituals, home fragrance, gifting, modern interiors",
  tags: [],
  msrpDollars: 85,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-09-01T22:13:27.017Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
